import { useFormBannerContent } from "context/formBanner/FormBannerContext";
import { useEffect, useState } from "react";
import Confetti from "react-confetti";

const FormBanner = () => {
	const { surveyBanner } = useFormBannerContent();
	const { title, subTitle, description, backgroundImageUrl, showConfetti } =
		surveyBanner;
	const [width, setWidth] = useState(window.innerWidth);
	const [height, setHeight] = useState(window.innerHeight);

	useEffect(() => {
		const handleResize = () => {
			setWidth(window.innerWidth);
			setHeight(window.innerHeight);
		};
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return (
		<div
			className={`relative ${backgroundImageUrl} bg-top bg-cover bg-h-[20px] h-[46dvh] text-white`}
		>
			<div className="absolute inset-0 bg-primary/90 !z-0"></div>
			<div className="relative !z-10 h-[32dvh] max-w-[90dvw] 2xl:max-w-screen-xl mx-auto py-4">
				<div className="flex items-center justify-between">
					<img src="/sproxillogo.png" alt="Sproxil Logo" />
				</div>
				<div className="h-auto flex flex-col items-start justify-center mt-3">
					<h1 className="text-3xl mb-4">{title}</h1>
					<p className="max-w-2xl text-sm">
						{subTitle}
						<br />
						{description}
					</p>
				</div>
			</div>
			{showConfetti && (
				<Confetti
					numberOfPieces={100}
					gravity={0.1}
					colors={["#FF69B4", "#FFC67D", "#8BC34A", "#BE0303"]}
					style={{
						width,
						height,
					}}
				/>
			)}
		</div>
	);
};

export default FormBanner;
